import {
  getSpace,
  getEvents
} from '../service/latest'

import {
  pageCount
}
from '../../../src/config'

export default {
    namespaced: true,
    state(){
        return {
            total: 0,
            used: 0,
            loadingspace: true,
            loadingevents: true,
            currentPage: 1,
            maxPage: false,
            events: [],
            loading: false
        }
    },
    mutations:{
        INIT(state,{noinit}){
            state.currentPage = 1
            state.maxPage = false
            if (!noinit) {
                state.total = 0
                state.used = 0
                state.loadingspace = true
                state.loadingevents = true
                state.loading = false
                state.events = []
            }
            
        },
        SAVE_SPACE(state,{total,used}){
            state.loadingspace = false
            state.total = total
            state.used = used
        },
        SAVE_EVENTS(state,{events,noinit}){
            state.loadingevents = false
            state.currentPage += 1
            state.maxPage = events.length < pageCount
            state.events = noinit ? events : state.events.concat(events)
        },
        SAVE_GROUP(state,groupid){
            state.groupid = groupid
        },
        LOADING(state,flag){
            state.loading = flag
        }
    },
    actions:{
        flush({commit,dispatch,state},{noinit}){
            commit('INIT',{noinit})
            dispatch('getEvents',{noinit:true,groupid: state.groupid})
            dispatch('getSpace')
        },
        getSpace({commit}){
            getSpace(({status,data}) =>{
                if (status === 200) {
                    commit('SAVE_SPACE', data)
                    let group
                    let autoGroup
                    data.groups.map(item => {
                      item.type == "special" ? group = item : ""
                      item.type == "tmp" ? autoGroup = item : ""
                    })
                    commit('SAVE_GROUPS', {group,autoGroup},{root:true})
                }else{
                    commit('TOAST',{
                        type: 'error',
                        msg: data.result
                    },{root: true})
                }
                
            })
        },
        getEvents({commit,state},paload){
            if (state.maxPage || state.loading) {
              return
            }
            commit('LOADING', true)
            commit('SAVE_GROUP',paload.groupid)
            let offset = (state.currentPage - 1) * pageCount
            getEvents({
              count: pageCount,
              offset,
              type: paload.type,
              groupid: paload.groupid
            },({status,data}) => {
                if (status === 200) {
                  data.noinit = paload && paload.noinit
                  commit('SAVE_EVENTS', data)
                } else {
                  commit('TOAST', {
                    type: 'error',
                    msg: data.result
                  }, {
                    root: true
                  })
                }
                commit('LOADING', false)
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/events.js